import { render, staticRenderFns } from "./article-tips-item.vue?vue&type=template&id=3a51e3eb&scoped=true"
import script from "./article-tips-item.vue?vue&type=script&lang=js"
export * from "./article-tips-item.vue?vue&type=script&lang=js"
import style0 from "./article-tips-item.vue?vue&type=style&index=0&id=3a51e3eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a51e3eb",
  null
  
)

export default component.exports